import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const BattleChart = ({ content }) => {
    const battleList = content?.results || [];
    const groupList = battleList?.['1/8决赛'] || [];
    const eightList = battleList?.['1/4决赛'] || [];
    const sixList = battleList?.['1/2决赛'] || [];
    const thirdPlace = battleList?.['季军战'] || [];
    const finals = battleList?.['决赛'] || [];

    const groupCss = [
        styles.group1,
        styles.group2,
        styles.group3,
        styles.group4,
        styles.group5,
        styles.group6,
        styles.group7,
        styles.group8,
    ];
    const eightTopCss = [styles.topEight1, styles.topEight2, styles.topEight3, styles.topEight4];
    const sixtopCss = [styles.topSix1, styles.topSix2, styles.topSix3];
    const countryNameFormat = (countryName) => {
        if (countryName === '沙特阿拉伯') {
            return '沙特';
        }
        if (countryName === '哥斯达黎加') {
            return '哥斯达...';
        }

        return countryName || '待定';
    };

    const formatMonthDay = (data) => {
        const dataTime = data || '';
        const dataTimeSplit = dataTime.split('-');
        const month = (dataTimeSplit[1] && `${dataTimeSplit[1]}.`) || '';
        const day = dataTimeSplit[2] || '';
        const monthDay = `${month}${day}`;

        return monthDay || '待定';
    };

    return (
        <div className={styles.battleChartBox}>
            <div className={styles.battleChart}>
                <div className={styles.battleBox}>
                    {groupList.map((item, index) => {
                        return (
                            <div key={item.id} className={`${styles.border1} ${groupCss[index]}`}>
                                <div className={styles.battleCountry}>
                                    <div className={styles.picText}>
                                        <div className={styles.pic}>
                                            {item?.icon1 && <img className={styles.flag} src={item.icon1} />}
                                        </div>
                                        <div className={styles.text}>{countryNameFormat(item.guojia1)}</div>
                                    </div>
                                    <div className={styles.picText}>
                                        <div className={styles.pic}>
                                            {item?.icon2 && <img className={styles.flag} src={item.icon2} />}
                                        </div>
                                        <div className={styles.text}>{countryNameFormat(item.guojia2)}</div>
                                    </div>
                                </div>
                                <div className={styles.battleTime}>{formatMonthDay(item?.date)}</div>
                            </div>
                        );
                    })}
                    {eightList.map((item, index) => {
                        return (
                            <div key={item.id} className={`${styles.border2} ${eightTopCss[index]}`}>
                                <div className={styles.battleCountry}>
                                    <div className={styles.picText}>
                                        <div className={styles.pic}>
                                            {item?.icon1 && <img className={styles.flag} src={item.icon1} />}
                                        </div>
                                        <div className={styles.text}>{countryNameFormat(item.guojia1)}</div>
                                    </div>
                                    <div className={styles.picText}>
                                        <div className={styles.pic}>
                                            {item?.icon2 && <img className={styles.flag} src={item.icon2} />}
                                        </div>
                                        <div className={styles.text}>{countryNameFormat(item.guojia2)}</div>
                                    </div>
                                </div>
                                <div className={styles.battleTime}>{formatMonthDay(item?.date)}</div>
                            </div>
                        );
                    })}

                    {sixList.map((item, index) => {
                        return (
                            <div key={item.id} className={`${styles.border2} ${sixtopCss[index]}`}>
                                <div className={styles.battleCountry}>
                                    <div className={styles.picText}>
                                        <div className={styles.pic}>
                                            {item?.icon1 && <img className={styles.flag} src={item.icon1} />}
                                        </div>
                                        <div className={styles.text}>{countryNameFormat(item.guojia1)}</div>
                                    </div>
                                    <div className={styles.picText}>
                                        <div className={styles.pic}>
                                            {item?.icon2 && <img className={styles.flag} src={item.icon2} />}
                                        </div>
                                        <div className={styles.text}>{countryNameFormat(item.guojia2)}</div>
                                    </div>
                                </div>
                                <div className={styles.battleTime}>{formatMonthDay(item?.date)}</div>
                            </div>
                        );
                    })}
                    {thirdPlace.map((item) => {
                        return (
                            <div key={item.id} className={`${styles.border2} ${styles.topSix3}`}>
                                <div className={styles.battleCountry}>
                                    <div className={styles.picText}>
                                        <div className={styles.pic}>
                                            {item?.icon1 && <img className={styles.flag} src={item.icon1} />}
                                        </div>
                                        <div className={styles.text}>{countryNameFormat(item.guojia1)}</div>
                                    </div>
                                    <div className={styles.picText}>
                                        <div className={styles.pic}>
                                            {item?.icon2 && <img className={styles.flag} src={item.icon2} />}
                                        </div>
                                        <div className={styles.text}>{countryNameFormat(item.guojia2)}</div>
                                    </div>
                                </div>
                                <div className={styles.battleTime}>{formatMonthDay(item?.date)}</div>
                            </div>
                        );
                    })}
                    {finals.map((item) => {
                        const guojia1score = (item.guojia1score && parseInt(item.guojia1score.split('(')?.[0])) || '0';
                        const guojia2score = (item.guojia2score && parseInt(item.guojia2score.split('(')?.[0])) || '0';
                        let winFlag = {
                            icon: '',
                            guojia: '',
                        };

                        if (guojia1score && guojia2score && item.isEnd && guojia1score > 0 && guojia2score > 0) {
                            if (guojia1score > guojia2score) {
                                winFlag = {
                                    icon: item?.icon1,
                                    guojia: item?.guojia1,
                                };
                            } else {
                                winFlag = {
                                    icon: item?.icon2,
                                    guojia: item?.guojia2,
                                };
                            }
                        }

                        return (
                            <div key={item.id} className={`${styles.border3} ${styles.finals}`}>
                                <div className={styles.battleCountry}>
                                    <div className={styles.picText3}>
                                        <div className={styles.pic3}>
                                            {item?.icon1 && <img className={styles.flag3} src={item.icon1} />}
                                        </div>
                                        <div className={styles.text3}>{countryNameFormat(item.guojia1)}</div>
                                    </div>
                                    <div className={styles.picText3}>
                                        <div className={styles.pic3}>
                                            <img
                                                className={styles.flag3Top}
                                                src="https://x0.ifengimg.com/ucms/2022_47/23F998F2E47DDA8290E3BC092E0AE3F615DCEDF5_size2_w48_h30.png"
                                            />
                                            {winFlag?.icon && <img className={styles.flag3} src={winFlag.icon} />}
                                        </div>
                                        <div className={styles.text4}>{countryNameFormat(winFlag.guojia)}</div>
                                    </div>
                                    <div className={styles.picText3}>
                                        <div className={styles.pic3}>
                                            {item?.icon2 && <img className={styles.flag3} src={item.icon2} />}
                                        </div>
                                        <div className={styles.text3}>{countryNameFormat(item.guojia2)}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <div className={`${styles.line1} ${styles.linePosition1}`} />
                    <div className={`${styles.line1} ${styles.linePosition2}`} />
                    <div className={`${styles.line2} ${styles.linePosition3}`} />
                    <div className={`${styles.line2} ${styles.linePosition4}`} />
                    <div className={`${styles.line3} ${styles.linePosition5}`} />
                    <div className={`${styles.line3} ${styles.linePosition6}`} />
                    <div className={`${styles.line4} ${styles.linePosition7}`} />
                    <div className={`${styles.line4} ${styles.linePosition8}`} />
                    <div className={`${styles.line5} ${styles.linePosition9}`} />
                    <div className={`${styles.line6} ${styles.linePosition10}`} />
                    <div className={`${styles.line7} ${styles.linePosition11}`} />
                    <div className={`${styles.line8} ${styles.linePosition12}`} />
                    <div className={`${styles.line9} ${styles.linePosition13}`} />
                    <div className={`${styles.line10} ${styles.linePosition14}`} />
                    <div className={`${styles.line11} ${styles.linePosition15}`} />
                </div>
            </div>
        </div>
    );
};

BattleChart.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(BattleChart);
